import { Component, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { EigentuemerListRequest, GbprintService } from '../../core/gb-api';
import { CapAlertService } from '../../core/extension/exceptions/cap-alert.service';
import { CapAlertLevel } from '../../core/extension/exceptions/cap-alert-level.enum';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { LocalLanguageService } from '../../core/services/local-language.service';
import { ContentHeaderComponent } from '../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../shared/components/title/title.component';
import { CapFormColumnsDirective } from '../../shared/form-control/form-columns.directive';
import { MetaDirective } from '../../shared/directives/meta.directive';
import { CapFormRowDirective } from '../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../shared/form-control/form-control.component';
import { MetaDisablerDirective } from '../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../shared/directives/meta-validator.directive';
import { keysToTranslate } from '../../../i18n/keys-to-translate';

@Component({
  selector: 'cap-eigentuemerliste',
  templateUrl: './eigentuemerliste.component.html',
  styleUrls: ['./eigentuemerliste.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    FormsModule,
    CapFormColumnsDirective,
    MetaDirective,
    CapFormRowDirective,
    CapFormControlComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    TranslatePipe
  ]
})
export class EigentuemerlisteComponent {
  @ViewChild('form', { static: false })
  form: NgForm;
  isValidInput = true;

  egridListText: string;

  eigentuemerListRequest: EigentuemerListRequest;
  eigentuemerList: string[] = [];

  constructor(
    private gbprintService: GbprintService,
    private capAlertService: CapAlertService,
    private translate: TranslateService,
    private localLanguageService: LocalLanguageService
  ) {
    keysToTranslate<string>(['eigentuemerAdressliste.egridList']);
  }

  onSubmit() {
    if (!this.egridListText) {
      const params = { fehlerMeldung: this.translate.instant('searchZuWenigSuchkriterien') };
      this.capAlertService.warning(this.translate.instant('ValidierungsFehler', params), CapAlertLevel.CONTENT_HEADER);
      return;
    }
    this.egridListText = this.egridListText.trim().replace(/\s+/g, ' ');
    this.eigentuemerList = this.egridListText.split(/[,;]+/);
    this.isValidInput = this.eigentuemerList.every((egrid) => /^CH\d{12}$/.test(egrid));
    if (this.isValidInput) {
      this.eigentuemerListRequest = {
        ids: this.eigentuemerList,
        language: this.localLanguageService.getLocalLanguage()
      };
      this.gbprintService.printEigentuemerAdressliste(this.eigentuemerListRequest).subscribe(() => {
        this.capAlertService.success(this.translate.instant('eigentuemerAdressliste.mizen'), CapAlertLevel.CONTENT_HEADER);
      });
    } else {
      this.capAlertService.warning(this.translate.instant('EingabeMussValideEgridSein'), CapAlertLevel.CONTENT_HEADER);
    }
  }

  onReset() {
    this.form.reset();
  }
}
